import client from "../Client/HttpClient";
import { IStudentAttendanceSessionsModel } from "@/interfaces/modules";

const ApiPath = "StudentAttendanceSessions";

export default {
    /** GET api/StudentAttendanceSessions */
    GetAll: (): Promise<IStudentAttendanceSessionsModel[]> =>
        client.get(`${ApiPath}`),

    /** GET api/StudentAttendanceSessions/{id} */
    GetById: (id: number): Promise<IStudentAttendanceSessionsModel> =>
        client.get(`${ApiPath}/${id}`),

    /** GET api/StudentAttendanceSessions/byPeriod/{periodId} */
    GetByPeriodId: (periodId: number): Promise<IStudentAttendanceSessionsModel[]> =>
        client.get(`${ApiPath}/byPeriod/${periodId}`),

    /** GET api/StudentAttendanceSessions/byCourseGroup/{courseGroupId} */
    GetByCourseGroupId: (courseGroupId: number): Promise<IStudentAttendanceSessionsModel[]> =>
        client.get(`${ApiPath}/byCourseGroup/${courseGroupId}`),

    /** GET api/StudentAttendanceSessions/byTeacher/{teacherId} */
    GetByTeacherId: (teacherId: number): Promise<IStudentAttendanceSessionsModel[]> =>
        client.get(`${ApiPath}/byTeacher/${teacherId}`),

    /** GET api/StudentAttendanceSessions/byDate?date=YYYY-MM-DD */
    GetByDate: (dateIso: string): Promise<IStudentAttendanceSessionsModel[]> =>
        client.get(`${ApiPath}/byDate`, { params: { date: dateIso } }),

    /** POST api/StudentAttendanceSessions */
    Post: (data: IStudentAttendanceSessionsModel): Promise<IStudentAttendanceSessionsModel> =>
        client.post(`${ApiPath}`, data),
};
